import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
let searchData = {
    Name: '',
    PageNumber: 1,
    PageSize: 25
}
let user = JSON.parse(localStorage.getItem("currentUser"));
export const getStaffInfo = (item) => {
    let url = `${API.Stafflist}?Name=${item.Name}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getStaffInfoListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getStaffInfoListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.post(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "postStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.put(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "updateStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "updateStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteStaffInfoList = (data) => {
    let url = `${API.PostStaff}`;
    return dispatch => {
        axios.put(url, data, {
            headers: {
                key: user.accessToken,
            }
        })
            .then((response) => {
                toast.success("Deleted Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                dispatch(getStaffInfo(searchData));
                dispatch({
                    type: "deleteStaffInfoSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteStaffInfoFailure",
                    error: "ERROR"
                })
            })
    }
}

